// /src/hooks/usePayPalScript.js
import { useEffect, useState } from 'react';

const usePayPalScript = () => {
  const [sdkLoaded, setSdkLoaded] = useState(false);

  useEffect(() => {
    if (window.paypal) {
      setSdkLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_Checkout_AutoFill}`;
    script.async = true;
    script.onload = () => setSdkLoaded(true);
    script.onerror = () => console.error('PayPal SDK failed to load');

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return sdkLoaded;
};

export default usePayPalScript;
